export interface ItemOption {
	readonly value: string;
	readonly label: string;
}

export const itemOptions: readonly ItemOption[] = [
	{ value: "perfil", label: "Perfil" },
	{ value: "componente", label: "Componente" },
];
